import apiClient  from './Client';

interface Page {
    id: string;
    children: any[];  // Replace `any` with a more specific type if known
    width: "auto" | number;
    height: "auto" | number;
    background: string;
    bleed: number;
    duration: number;
  }
  
  // Interface for Pages Data
  interface PagesData {
    width: number;
    height: number;
    fonts: string[];  // assuming fonts as an array of strings
    pages: Page[];
    audios: any[];    // Replace `any` with specific type if known
    unit: "px" | "cm" | "in";  // assuming only these units
    dpi: number;
  }
class PhotobookEditorService{ 
      
      // Function return type
    async GetPhotobookPages(): Promise<PagesData> {
        const pagesData: PagesData = {
          width: 300,
          height: 400,
          fonts: [],
          "pages": [
            {
                "id": "A6qyqjsK5I",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            },
            {
                "id": "p2_Of9yGcl",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            },
            {
                "id": "0ewU1zxfSC",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            },
            {
                "id": "0UlkPH5PwD",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            },
            {
                "id": "qQtCGYd__R",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            },
            {
                "id": "zkS0ENeUkL",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            },
            {
                "id": "OauEFwZ2Rn",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            },
            {
                "id": "LBvoMMOhr6",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            },
            {
                "id": "WyaOSe2VCl",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            },
            {
                "id": "yzZSIvlmYy",
                "children": [],
                "width": "auto",
                "height": "auto",
                "background": "white",
                "bleed": 0,
                "duration": 5000
            }
        ],
        "audios": [],
        "unit": "px",
        "dpi": 72
        };
      
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(pagesData);
          }, 1000);
        });
    }
    async CreatePhotobook(productId: number, albumData: any) { 
      console.log(productId);
      console.log(albumData);
        try {
        const response = await apiClient.post(`/PhotoAlbum/${productId}/create`, albumData); 
        console.log(response);
        return response.data;
          
        } catch (err:any) {
          if(err.response.status===400)
          {
            console.log(err); 
            if(err.response.data.message==="Error in creating new PhotoAlbum")
              return "Failed to create PhotoAlbum";
          }
            
        }
    };

    async UpdatePhotobook(albumId: number, albumData: any) { 
      try {
      const response = await apiClient.put(`/PhotoAlbum/update/${albumId}`, albumData); 
      console.log(response);
      return response.data;
        
      } catch (err:any) {
        if(err.response.status===400)
        {
          console.log(err); 
          if(err.response.data.message==="Error in creating new PhotoAlbum")
            return "Failed to create PhotoAlbum";
        }
          
      }
  };

  async GetPhotobook(albumId: number){
    try {
      const response = await apiClient.get(`/PhotoAlbum/get/${albumId}`);
      return response.data;
    } catch (error) {
        console.error("Failed to fetch PhotoAlbum", error);
        throw error;  
    }
  }
}
export default new PhotobookEditorService()